<div class="time-circle-info alt-column-align-center">
  <div class="time-circle">
    <circle-progress
      [options]="optionsGraph"
      [percent]="100"
      [radius]="54"
      [innerStrokeWidth]="16"
      [innerStrokeColor]="color"
    ></circle-progress>
    <div class="time-text alt-column-align-center">
      <p class="alt-inter-bold alt-size-24 alt-color-grayscale2">
        {{ timeNumber }}
      </p>
      <p class="time-date alt-inter-bold alt-size-16 alt-color-grayscale2">
        {{ timeText ?? "" | translate }}
      </p>
    </div>
  </div>
  <p
    class="alt-inter-medium alt-size-16 alt-color-grayscale2 alt-text-align-center"
  >
    {{ title | translate }}
  </p>
</div>
